module.exports = __webpack_public_path__ + "static/media/website-13.c8de19e2.mp4";